
import { defineComponent, ref, watch } from 'vue';
import { compile } from 'path-to-regexp';
import { RouteRecord, useRoute, useRouter } from 'vue-router';

// 首页路由配置
export const HOME_ROUTE: Partial<RouteRecord> = {
  path: '/dashboard',
  name: 'dashboard',
  meta: {
    title: '首页',
    icon: 'document',
  },
};

// 获取路由记录列表
function useBreadcrumbList() {
  const currentRoute = useRoute();
  const breadcrumbList = ref<RouteRecord[]>([]);

  // 是否为首页
  const isDashboard = (route: RouteRecord) => {
    const name = route && route.name as string;
    if (!name || !HOME_ROUTE.name) {
      return false;
    }
    return name.trim().toLowerCase() === (HOME_ROUTE.name as string).toLowerCase();
  };

  // 获取路由记录列表
  const getBreadcrumbList = () => {
    // 获取带标题的路由
    let matched = currentRoute.matched.filter(
      item => item.meta && item.meta.title && item.meta.breadcrumb !== false,
    );
    const [first] = matched;

    if (!isDashboard(first)) {
      matched = [HOME_ROUTE as RouteRecord].concat(matched);
    }

    breadcrumbList.value = matched;
  };

  // 监听 重新获取 路由记录
  watch(
    () => {
      return currentRoute.path;
    },
    (path) => {
      // if you go to the redirect page, do not update the breadcrumbs
      if (path.startsWith('/redirect/')) {
        return;
      }
      getBreadcrumbList();
    },
  );
  // 初始化
  getBreadcrumbList();
  return {
    breadcrumbList,
  };
}

export default defineComponent({
  name: 'Breadcrumb',
  setup() {
    const currentRouter = useRouter();
    const currentRoute = useRoute();
    const { breadcrumbList } = useBreadcrumbList();

    const pathCompile = (path: string) => {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = currentRoute;
      const toPath = compile(path);
      return toPath(params);
    };

    const onClickBreadcrumb = (item: RouteRecord, index: number) => {
      const currentPath = currentRoute.path;
      const { path } = item;
      const { redirect } = item;

      const childItem = breadcrumbList.value[index + 1];
      const { activeMenu, breadcrumbLink } = childItem?.meta || {};
      const _handleLink = breadcrumbLink || activeMenu;

      // 跳转的路径
      const toPath = typeof _handleLink === 'function' ? _handleLink(currentRoute) : _handleLink || redirect;

      // 跳转地址 等于当前地址 不做任何操作
      if (toPath && toPath === currentPath) {
        return;
      }

      if (toPath) {
        currentRouter.push(toPath as string);
        return;
      }

      const url = pathCompile(path);
      currentRouter.push(url);
    };

    return {
      onClickBreadcrumb,
      breadcrumbList,
    };
  },
});
